import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['otpRequired', 'otpDetails'];

  otpRequiredTargetConnected = (target) => {
    target.addEventListener('click', this.toggleOtpDetails.bind(this));
    this.toggleOtpDetails();
  };

  toggleOtpDetails = () => {
    if(this.hasOtpDetailsTarget) {
      this.otpDetailsTarget.style.display = this.otpRequiredTarget.checked ? '' : 'none';
    }
  };
}
